import { SITE_URL } from '../constants';

/**
 * Converts a relative path or URL to an absolute URL based on the site configuration.
 */
export const toAbsoluteUrl = (path: string): string => {
  if (!path) return SITE_URL;
  if (path.startsWith('http')) return path;
  
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  // Using constant SITE_URL as the base to ensure stability across environments
  return `${SITE_URL}${cleanPath}`;
};
